import { TutorCruncherSignupResponse } from 'types/Api';
import { TutorCruncherSignUpTutorActionType } from './actions';
import { logSafelyToConsole } from 'utils';

const {
  TUTORCRUNCHER_SIGNUP_TUTOR_REQUEST,
  TUTORCRUNCHER_SIGNUP_TUTOR_SUCCESS,
  TUTORCRUNCHER_SIGNUP_TUTOR_ERROR
} = TutorCruncherSignUpTutorActionType;

export interface TutorCruncherSignUpTutorState {
  loading: boolean;
  tutorId: number | undefined;
  error: boolean;
}

export default function reducer(
  state: TutorCruncherSignUpTutorState,
  action: {
    type: TutorCruncherSignUpTutorActionType;
    payload: { response: TutorCruncherSignupResponse } | null;
  }
): TutorCruncherSignUpTutorState {
  const { type, payload } = action;

  logSafelyToConsole(type);
  switch (type) {
    case TUTORCRUNCHER_SIGNUP_TUTOR_REQUEST: {
      return {
        ...state,
        loading: true,
        error: false
      };
    }
    case TUTORCRUNCHER_SIGNUP_TUTOR_SUCCESS: {
      if (payload) {
        const { response } = payload;
        return {
          ...state,
          loading: false,
          error: false,
          tutorId: response.data.id
        };
      } else {
        return {
          ...state,
          loading: false,
          error: true
        };
      }
    }
    case TUTORCRUNCHER_SIGNUP_TUTOR_ERROR: {
      return {
        ...state,
        loading: false,
        error: true
      };
    }
    default:
      return state;
  }
}
